
import { Alert, Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import React, { FC } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { DeleteIcon } from '../../../../vectors/index';
import DeleteMuiIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';
import { useGetAssignedTagApplicats } from '@features/applications/hooks/useGetAssignedTagApplicats';
import { useDeleteEmployertags } from '@features/applications/hooks/useDeleteEmployertags';
import { useGetEmployerAssignedTagApplicats } from '@features/applications/hooks/useGetEmployerAssignedTagApplicats';

type Tag = {
  id: number;
  tag: string;
};

type DeleteEmployerTagModalProps = {
  handleClose: () => void;
  deleteTag: Tag
};

const DeleteEmployerTagModal: FC<DeleteEmployerTagModalProps> = ({
  handleClose,
  deleteTag
}) => {
  const [errorText, setErrorText] = React.useState<string>('');
  const { deleteTags, isDeleteTagsLoading } = useDeleteEmployertags({ setErrorText })

  const { assignedApplicantsCount, isLoadingCount } = useGetEmployerAssignedTagApplicats({ setErrorText, id: deleteTag?.id })

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const options = {
      onSuccess: (data: { message: string }) => {
        toast.success(data.message)
        handleClose();
      },
    };
    deleteTags({ tag_id: deleteTag?.id }, options)
  };


  return (
    <>
      <Dialog
        open
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        disableEnforceFocus
      >
        <DialogTitle>
          <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
          <br />
          <DeleteIcon />
          <br />
          <Typography variant="h4" sx={{ p: 3 }}>
            {deleteTag && <span>Are you sure you want to delete <b>{deleteTag.tag}</b>
              tag? It will be unassigned from all applicants.</span>}
            {!isLoadingCount && assignedApplicantsCount && (
              <span>
                <br />
                <b>{assignedApplicantsCount?.count == 0 ? 'No' : assignedApplicantsCount?.count}</b>
                {((assignedApplicantsCount?.count == 1) || (assignedApplicantsCount?.count == 0)) ? ' applicant is ' : ' applicants are '}assigned to this tag.
              </span>
            )}
          </Typography>
        </DialogTitle>

        <DialogContent>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <form onSubmit={handleSubmit}>
            <Button
              sx={{ mb: 2, width: '100%' }}
              startIcon={<DeleteMuiIcon />}
              disabled={isDeleteTagsLoading && !isLoadingCount}
              variant="contained"
              type="submit"
              color="error" >
              {isDeleteTagsLoading ? 'Deleting...' : 'Delete'}
            </Button>
          </form>
        </DialogContent >
      </Dialog >
    </>
  );
};

export default DeleteEmployerTagModal;
